var exports = {
  "zr": "root__40XFef",
  "N4": "titleButton__j5oNXm",
  "Qw": "titleText__FxxPk3",
  "O3": "environmentVisual__Zpohpt",
  "IB": "titleChevron__JJH9hE",
  "Lw": "overlay__WICWLG",
  "F3": "sessionInfo__TkQiTA",
  "$8": "sessionDetails__L4QEX7",
  "gs": "sessionDetail__nzXNnv",
  "ct": "sessionDetailLabel__sbR6tA",
  "BV": "sessionDetailValue__UvEsdU",
  "VE": "environmentName__vJSRCr",
  "at": "branchName__nc_Zhk",
  "wP": "monospace__ZdX5K2",
  "CX": "wrappingValue__lKKV9l",
  "n2": "copyButtonWrapper__zk0dwy",
  "Iw": "environmentLink__f1NyiK",
  "Zg": "ownerAvatar__ZpyL3h",
  "v8": "stackedValue__2cm_y9",
  "du": "tokenLines__vDvJLG",
  "S2": "tokenLine__32ozbI",
  "PE": "tokenIcon__6a7bgO",
  "kj": "usageSummary__Uor_Y2",
  "yM": "usageNote__8ZRxfe",
  "jj": "contextMeter__itVBOq",
  "qL": "sessionActions__diP0Sl",
  "d0": "staffInfo__KzLREm",
  "SW": "staffHeader__5JJgm_",
};

module.exports = exports;
